import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { switchMap, take, filter } from 'rxjs/operators';
import { IResponseSuccess } from '@core/interfaces';
import { Store as StoreModel, DeliveryZoneCustomer } from '@core/models';
import { Store } from '@ngrx/store';
import { AppState } from '@store/reducers';
import { selectStore } from '@store/selectors';

@Injectable({
	providedIn: 'root',
})
export class DeliveryZoneCustomerService {
	store$: Observable<StoreModel | null>;

	constructor(
		private http: HttpClient,
		private store: Store<AppState>
	) {
		this.store$ = this.store.select(selectStore);
	}

	findAll(clientId: string | null): Observable<IResponseSuccess<DeliveryZoneCustomer>> {
		return this.store$.pipe(
			filter((store): store is StoreModel => !!store),
			filter(() => !!clientId),
			switchMap(store => {
				return this.http.get<IResponseSuccess<DeliveryZoneCustomer>>(
					`${environment.microSeguridades}/pos/cliente-zonaentrega`,
					{
						params: {
							localId: store.idLocal,
							clienteId: clientId as string,
						},
						headers: {
							authorization: store.apiKey,
						},
					}
				);
			}),
			take(1)
		);
	}
}
